/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Agreement_LegendInputs */

const en_case_payment_agreement_legend = /** @type {(inputs: Case_Payment_Agreement_LegendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negotiated conditions`)
};

const pt_br2_case_payment_agreement_legend = /** @type {(inputs: Case_Payment_Agreement_LegendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condições negociadas`)
};

/**
* | output |
* | --- |
* | "Negotiated conditions" |
*
* @param {Case_Payment_Agreement_LegendInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_agreement_legend = /** @type {((inputs?: Case_Payment_Agreement_LegendInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Agreement_LegendInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_agreement_legend(inputs)
	return pt_br2_case_payment_agreement_legend(inputs)
});